import { render, staticRenderFns } from "./ot-issues-layout.vue?vue&type=template&id=12317570&scoped=true&"
import script from "./ot-issues-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-issues-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-issues-layout.vue?vue&type=style&index=0&id=12317570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12317570",
  null
  
)

export default component.exports